export default {
  login: "FrontEnd/login",
  getNewAccessToken: "FrontEnd/getNewAccessToken",
  changePassword: "BackEnd/changePassword",
  getImg: "authfiles/getfiles/",
};
